<script lang="ts">
  import Image from "$lib/atoms/Image.svelte";
  import type { GalleryImageStoryblok } from "$types/components";

  export let blok: GalleryImageStoryblok;
  export let aspectRatio = "16-9";
  export let isFullScreen = false;
</script>

<div class="gallery-image">
  <div class="content">
    {#if blok.image}
      <Image
        media={blok.image}
        aspect={aspectRatio}
        smSize="100"
        lgSize={isFullScreen ? "83vw" : "50vw"}
      />
    {/if}
  </div>
</div>

<style lang="scss">
  .gallery-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: scale(1.2);
  }

  .content {
    height: 100%;
    width: 100%;
  }
</style>
